import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route, Navigate } from "react-router-dom";
import ScrollToTop from "./components/ScrollToTop";
import ErrorBoundary from "./components/ErrorBoundary";
import AdminRoutes from "./AdminRoutes";
import { AdminAuthProvider } from "./context/AdminAuthContext";
import { ToastProvider } from "./context/ToastContext";
import LandingPage from "./pages/home";

function App() {
  return (
    <BrowserRouter>
      <AdminAuthProvider>
        <ToastProvider>
        <ErrorBoundary>
          <ScrollToTop />
          <RouterRoutes>
            {/* Public Landing */}
            <Route path="/" element={<LandingPage />} />

            {/* ADMIN APP */}
            <Route path="/admin/*" element={<AdminRoutes />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/" replace />} />
          </RouterRoutes>
        </ErrorBoundary>
        </ToastProvider>
      </AdminAuthProvider>
    </BrowserRouter>
  );
}

export default App;
